const scrollTopResults = containerClass => {
  const resultsElt = document.querySelector(containerClass);
  if (resultsElt) {
    window.scrollTo({ top: resultsElt.offsetTop - (document.querySelector('header').clientHeight + 50), behavior: 'smooth' })
  }
};

export { scrollTopResults };